<template>
  <b-card>
    <!-- form -->
    <validation-observer ref="editUser">
      <b-form
          class="mt-2"
          @submit.prevent="handleSubmit"
          @keydown.enter="handleSubmit"
      >
        <b-row>
          <b-col
              cols="12"
              class="mb-2 auth-create-form d-flex justify-content-center"
          >
            <ImageDropzone
                ref="images"
                :files="files"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group
                label="Nombre"
                label-for="account-name"
            >
              <b-form-input
                  v-model="user.name"
                  name="name"
              />
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
                label="Apellidos"
                label-for="account-surname"
            >
              <b-form-input
                  v-model="user.surname"
                  name="surname"
              />
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
                label="Teléfono"
                label-for="account-phone"
            >
              <b-form-input
                  v-model="user.phone"
                  name="phone"
              />
            </b-form-group>
          </b-col>

          <b-col
              cols="12"
              class="d-flex justify-content-end"
          >
            <b-button
                type="submit"
                variant="primary"
                class="mt-2 mr-1"
            >
              Guardar
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapActions } from 'vuex'
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BCard,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import Ripple from 'vue-ripple-directive'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import ImageDropzone from '@/components/elements/ImageDropzone/ImageDropzone.vue'
import { ref } from '@vue/composition-api'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    ImageDropzone,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    generalData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      files: [],
      user: this.generalData,
      profileFile: null,
      required,
      email,
    }
  },
  created() {
    const avatar = {
      name: 'Avatar',
      url: process.env.VUE_APP_IMAGE_PLACEHOLDER,
      urlDelete: `/users/delete_image/${this.generalData.id}`,
    }
    if (this.generalData.avatar !== null) {
      avatar.url = this.generalData.avatar
    }
    this.files = [avatar]
    this.user = this.generalData
  },
  methods: {
    ...mapActions({
      edit: 'users/edit',
    }),
    resetForm() {
      this.user = JSON.parse(JSON.stringify(this.generalData))
    },
    handleSubmit() {
      this.$refs.editUser.validate().then(success => {
        if (success) {
          const { id } = this.user
          const formData = this.createFormData()
          if (formData) {
            this.edit({ id, user: formData })
          }
        }
      })
    },
    createFormData() {
      const data = this.$refs.images.getFormData()

      data.append('name', this.user.name)
      data.append('email', this.user.email)
      data.append('phone', this.user.phone)
      data.append('surname', this.user.surname)
      data.append('active', this.user.active)
      // data.append('lang', this.user.lang)

      return data
    },
  },
  setup() {
    const refInputEl = ref(null)
    const previewEl = ref(null)

    const { inputImageRenderer } = useInputImageRenderer(refInputEl, previewEl)

    return {
      refInputEl,
      previewEl,
      inputImageRenderer,
    }
  },
}
</script>
